import { getListApiHttpParam, mapToListModel } from '@aston/foundation/functions';
import { combineLatest, map, Observable, switchMap } from 'rxjs';
import { IList, IListState } from '@aston/foundation/models';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';

import { PortalRequestsListSortProp } from '../enums/portal-requests-list-sort-prop.enum';
import { CreateDebtorPortalRequestApi } from '../models/request-create.api';
import { mapToDebtorPortalRequest } from '../functions/mappers.request';
import { AppStoreSelectors } from '../../root-store/app-store';
import { PortalRequest } from '../models/request.model';


@Injectable({ providedIn: 'root' })
export class PortalRequestsService {

	private http = inject(HttpClient)
	private store = inject(Store)

	base$: Observable<string> = combineLatest([
		this.store.select(AppStoreSelectors.selectConfig),
		this.store.select(AppStoreSelectors.selectTenant),
	]).pipe(map(([config, tenant]) => `${config.apiUrl}/${tenant.superDebtorId}`))

	listRequests(params: IListState<PortalRequestsListSortProp>): Observable<IList<PortalRequest>> {
		const httpParams = getListApiHttpParam(params);
		return this.base$.pipe(
			switchMap(apiUrl => this.http.get<IList<PortalRequest>>(`${apiUrl}/portalRequests`, {params: httpParams}).pipe(
				map(apiModel => mapToListModel<PortalRequest, PortalRequest>(apiModel, mapToDebtorPortalRequest))
			))
		);
	}	

	cancelRequest(portalRequestId: number) {
		return this.base$.pipe(
			switchMap(apiUrl => this.http.post(`${apiUrl}/${portalRequestId}/delete`, {}))
		);
	}

	createRequest(dunningActionId: number, model: CreateDebtorPortalRequestApi) {
		return this.base$.pipe(
			switchMap(apiUrl => this.http.post(`${apiUrl}/${dunningActionId}/request`, model))
		);
	}
}
